<template>
  <v-card>
    <v-toolbar flat dense>
      <span class="text-subtitle-1">Agent Statistics</span>
    </v-toolbar>
    <div>
      <v-data-table
        :footer-props="{
          'items-per-page-options': [-1]
        }"
        :headers="headers"
        hide-default-footer
        :items="agents"
        :item-key="Math.random(10).toString()"
        :loading="$apollo.loading"
        :sort-by="['conversionRate']"
        :sort-desc="[true]"
      >
        <template v-slot:item.conversionRate="props">
          {{ props.item.conversionRate }}%
        </template>
        <template v-slot:body.append>
          <tr class="font-weight-medium">
            <td>Total</td>
            <td>{{ totals.totalLeads }}</td>
            <td>{{ totals.totalWanted }}</td>
            <td>{{ totals.totalWantedSigned }}</td>
            <td>{{ totals.conversionRate }}%</td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
import gql from "graphql-tag";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headers: [
        { text: "Agent", value: "agent" },
        { text: "Leads", value: "totalLeads" },
        { text: "Wanted", value: "totalWanted" },
        { text: "Signed", value: "totalWantedSigned" },
        { text: "Conversion", value: "conversionRate" }
      ]
    };
  },
  computed: {
    ...mapGetters(["startDate", "endDate"]),
    agents() {
      if (!this.agentStats) return [];
      return this.agentStats;
    },
    totals() {
      const totalLeads = this.agents.reduce(
        (sum, agent) => sum + (agent.totalLeads || 0),
        0
      );
      const totalWanted = this.agents.reduce(
        (sum, agent) => sum + (agent.totalWanted || 0),
        0
      );
      const totalWantedSigned = this.agents.reduce(
        (sum, agent) => sum + (agent.totalWantedSigned || 0),
        0
      );
      const conversionRate =
        totalWanted === 0
          ? 0
          : Math.round((totalWantedSigned / totalWanted) * 10000) / 100;

      return { totalLeads, totalWanted, totalWantedSigned, conversionRate };
    }
  },
  apollo: {
    agentStats: {
      query: gql`
        query OrgIntakeAgentStats($startDate: String!, $endDate: String!) {
          agentStats: leadDocketAgentStats(
            startDate: $startDate
            endDate: $endDate
          ) {
            agent
            totalLeads
            totalWanted
            totalWantedSigned
            conversionRate
          }
        }
      `,
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate
        };
      },
      skip() {
        return this.startDate === null || this.endDate === null;
      }
    }
  }
};
</script>

<style scoped></style>
